export var noop = function noop() {};


//////////////////
// WEBPACK FOOTER
// ./~/bootstrap-vue/esm/utils/noop.js
// module id = 166
// module chunks = 0